import { MatrixDescriptor } from './types';

export const HUMANAS_LINGUAGENS_DESCRIPTORS: MatrixDescriptor[] = [
  // --- LINGUAGENS ---
  {
    id: 'POR_D1',
    subject: 'LINGUAGENS',
    code: 'D1',
    theme: 'Tema 1 – Procedimentos de leitura',
    description: 'Interpretar textos em linguagem verbal e não verbal.',
    keywords: ['interpretação de texto', 'linguagem verbal', 'não verbal', 'charge', 'tirinha'],
  },
  {
    id: 'POR_D2',
    subject: 'LINGUAGENS',
    code: 'D2',
    theme: 'Tema 1 – Procedimentos de leitura',
    description: 'Diferenciar ideias centrais de secundárias; tópicos de subtópicos; tese de argumentos em um texto.',
    keywords: ['ideia central', 'tese', 'argumento principal', 'tópico frasal'],
  },

  // --- HUMANAS ---
  {
    id: 'GEO_D1',
    subject: 'HUMANAS',
    code: 'D1',
    theme: 'Tema 1 – Leitura e interpretação cartográfica',
    description: 'Reconhecer na linguagem cartográfica e seus produtos formas indispensáveis para visualizar fenômenos naturais e humanos segundo localizações geográficas.',
    keywords: ['mapa', 'cartografia', 'escala', 'projeção', 'coordenadas'],
  },
  {
    id: 'HIS_D1',
    subject: 'HUMANAS',
    code: 'D1',
    theme: 'Tema 1 – História, cultura e sociedade',
    description: 'Identificar os principais elementos dos sistemas políticos, econômicos e culturais de organização da vida social.',
    keywords: ['sociedade', 'sistema político', 'feudalismo', 'capitalismo', 'estado moderno'],
  },
];
